import { createEvent } from 'effector';

export const closeStartPage = createEvent();
